import { useEffect, useState } from "react";

const KEY = "theme";
export const THEMES = [
  { key: "light", label: "Luminos", dot: "#F6F4EF" },
  { key: "dark", label: "Întunecat", dot: "#12141C" },
  { key: "glass", label: "Liquid Glass", dot: "linear-gradient(135deg,#7C3AED,#0EA5E9,#EC4899)" },
  { key: "glass-light", label: "Liquid Glass luminos", dot: "linear-gradient(135deg,#C7D2FE,#BAE6FD,#FBCFE8)" },
];
const current = () => (THEMES.some((t) => t.key === localStorage.getItem(KEY)) ? localStorage.getItem(KEY) : "light");
export const isLight = (t) => t === "light" || t === "glass-light";

const apply = (t) => {
  const el = document.documentElement;
  el.classList.toggle("light", isLight(t));
  el.classList.toggle("dark", !isLight(t));
  el.classList.toggle("glass", t.startsWith("glass"));
  const meta = { light: "#FFFFFF", dark: "#0B0D13", glass: "#0B0A1A", "glass-light": "#EEF2FF" }[t];
  document.querySelectorAll('meta[name="theme-color"]').forEach((m) => { m.content = meta; });
  window.dispatchEvent(new Event("themechange"));
};

export const initTheme = () => apply(current());
export const setTheme = (t) => { localStorage.setItem(KEY, t); apply(t); };

export function useTheme() {
  const [theme, setT] = useState(current);
  useEffect(() => {
    const onChange = () => setT(current());
    window.addEventListener("themechange", onChange);
    return () => window.removeEventListener("themechange", onChange);
  }, []);
  return theme;
}
